import _extends from '@babel/runtime/helpers/extends';
import { fontSizes } from '../constants/font-sizes.js';
import { lineHeights } from '../constants/line-heights.js';
import { FontSize } from './types.js';

var contentTextAttributesWeb = {
  color: 'text',
  defaultSize: FontSize.m,
  fontSizes: fontSizes,
  lineHeights: lineHeights
};
var contentTextThemeWeb = _extends({}, contentTextAttributesWeb, {
  variants: {
    condensed: {
      defaultSize: FontSize.s
    }
  }
});
var contentTextAttributesNative = {
  defaultSize: FontSize.m,
  fontSizes: fontSizes,
  lineHeights: lineHeights
};
var contentTextThemeNative = _extends({}, contentTextAttributesNative, {
  variants: {
    condensed: {
      defaultSize: FontSize.s
    }
  }
});

export { contentTextThemeNative, contentTextThemeWeb };
